/* eslint-disable */

$(document).ready(function () {

  $(".collection-extra-link").on( "mouseover", function () {
    popupWidth = $(this).children("span").outerWidth();
    spanWidth = $(this).outerWidth();
    $(this).children("span").fadeIn(200);
    $(this).children("span").css("left",-popupWidth/2+spanWidth/2)
  });

  $(".collection-extra-link").on( "mouseout", function () {
    $(this).children("span").fadeOut(100);
  });

});
